var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"fullscreen":_vm.fullscreen,"persistent":_vm.persistent,"max-width":_vm.maxWidth,"value":_vm.showDialog},on:{"input":function($event){return _vm.$emit('close')}}},[_c('v-card',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }